// extracted by mini-css-extract-plugin
module.exports = {"ErrorIntroBlock":"ErrorIntroBlock_ErrorIntroBlock__dvNgT"};